import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { CustomerModel } from '@df/session/api/customer.model';
import './gtm-event-customer-data';

@Injectable({
    providedIn: 'root'
})
export class GtmEventCustomerDataTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Customer model
     */
    private customerModel = inject(CustomerModel);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'customerDataChange' && this.customerModel.loaded) {
                this.dispatch(event);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData) {
        return this.gtmService.dispatch({
            event: 'customer_data',
            customer: this.customerModel.data,
            triggerContext: {
                trigger
            }
        });
    }
}
